import { useContext, useEffect, useMemo, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import alpsLogo from "../assets/alps.jpg";
import achatLogo from "../assets/achat.jpg";
import tennisLogo from "../assets/tennispoint.jpg";
import uhlLogo from "../assets/uhl.jpg";
import last from "../assets/last.png";

/** ---------------------------
 *  Local shops config (Option 1)
 *  Add/edit rows here—no more <tr> duplication
 * --------------------------- */
const buildShops = (t, handleBeachcomClick) => ([
  {
    id: "beachcom",
    logoSrc: "https://beachcom.de/img/logo.png",
    altKey: "_market.beachcom_title",
    titleKey: "_market.beachcom_title",
    descriptionKey: "_market.beachcom_description",
    action: { type: "custom", handler: handleBeachcomClick },
  },
  {
    id: "vacationize",
    logoSrc: "https://beachcom.de/img/logo.png",
    altKey: "_market.vacationize_title",
    titleKey: "_market.vacationize_title",
    descriptionKey: "_market.vacationize_description",
    action: { type: "modal", htmlDescriptionKey: "_market.vacationize_description_html", link: "https://beachcom.de/Cmspages/lastMinute" },
  },
  {
    id: "aiakus",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.aiakus_title",
    titleKey: "_market.aiakus_title",
    descriptionKey: "_market.aiakus_description",
    action: { type: "modal", htmlDescriptionKey: "_market.aiakus_description_html", link: "https://www.aiakus.de" },
  },
  {
    id: "sportmeeting_de",
    logoSrc: "https://sportmeeting.de/img/logo.png",
    altKey: "_market.sportmeeting_title",
    titleKey: "_market.sportmeeting_title",
    descriptionKey: "_market.sportmeeting_de_description",
    action: { type: "modal", htmlDescriptionKey: "_market.sportmeeting_description_html", link: "https://www.sportmeeting.de" },
  },
  // {
  //   id: "sportmeeting_com",
  //   logoSrc: "https://sportmeeting.de/img/logo.png",
  //   altKey: "_market.sportmeeting_title",
  //   titleKey: "_market.sportmeeting_title",
  //   descriptionKey: "_market.sportmeeting_com_description",
  //   action: { type: "modal", htmlDescriptionKey: "_market.sportmeeting_description_html_1", link: "https://www.sportsmeeting.com" },
  // },
  {
    id: "lowa",
    logoSrc: "/logos/lowa.jpg",
    altKey: "_market.lowa_title",
    titleKey: "_market.lowa_title",
    descriptionKey: "_market.lowa_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=4690846&v=122662&q=597094&r=393339" },
  },
  {
    id: "jochen_schweizer_arena",
    logoSrc: "/logos/jochen_schweizer_arena.png",
    altKey: "_market.jochen_schweizer_title",
    titleKey: "_market.jochen_schweizer_title",
    descriptionKey: "_market.jochen_schweizer_description",
    action: { type: "modal", htmlDescriptionKey: "_market.jochen_schweizer_description_html", link: "https://www.jochen-schweizer.de/arena" },
  },
  {
    id: "zen_hotels",
    logoSrc: "/logos/zen_hotels.svg",
    altKey: "_market.zen_hotels_title",
    titleKey: "_market.zen_hotels_title",
    descriptionKey: "_market.zen_hotels_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=3955209&v=115953&q=520699&r=393339" },
  },
  {
    id: "a_rosa",
    logoSrc: "/logos/a_rosa.svg",
    altKey: "_market.a_rosa_title",
    titleKey: "_market.a_rosa_title",
    descriptionKey: "_market.a_rosa_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=2183367&v=11707&q=339634&r=393339" },
  },
  {
    id: "lastminute366",
    logoSrc: last,
    altKey: "_market.lastminute366_title",
    titleKey: "_market.lastminute366_title",
    descriptionKey: "_market.lastminute366_description",
    action: { type: "newtab", link: "https://b2b.specials.de/index/jump/119/2780/992850/" },
  },
  {
    id: "eurocamp",
    logoSrc: "https://a1.awin1.com/ads/awin/14888/imgeurocamp_2023_75x75-1672156595008.png",
    altKey: "_market.eurocamp_title",
    titleKey: "_market.eurocamp_title",
    descriptionKey: "_market.eurocamp_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=2464876&v=14888&q=371346&r=393339" },
  },
  {
    id: "sunparks",
    logoSrc: "/logos/sunparks.gif",
    altKey: "_market.sunparks_title",
    titleKey: "_market.sunparks_title",
    descriptionKey: "_market.sunparks_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=2517883&v=14749&q=376858&r=393339" },
  },
  {
    id: "centerparcs",
    logoSrc: "/logos/centerparcs.png",
    altKey: "_market.centerparcs_title",
    titleKey: "_market.centerparcs_title",
    descriptionKey: "_market.centerparcs_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=3292715&v=13639&q=453148&r=393339" },
  },
  {
    id: "check24",
    logoSrc: "/logos/check24.jpg",
    altKey: "_market.check24_title",
    titleKey: "_market.check24_title",
    descriptionKey: "_market.check24_description",
    action: { type: "newtab", link: "https://www.awin1.com/awclick.php?gid=332974&mid=9364&awinaffid=393339&linkid=2126275&clickref=" },
  },
  {
    id: "flights",
    logoSrc: "/logos/flights.png",
    altKey: "_market.flights_title",
    titleKey: "_market.flights_title",
    descriptionKey: "_market.flights_description",
    action: { type: "newtab", link: "https://beachcom.de/Cmspages/flights" },
  },
  {
    id: "ferries",
    logoSrc: "/logos/ferries.png",
    altKey: "_market.ferries_title",
    titleKey: "_market.ferries_title",
    descriptionKey: "_market.ferries_description",
    action: { type: "newtab", link: "https://www.faehreonline.com/?ap=UZRX0" },
  },
  {
    id: "rentalcars",
    logoSrc: "/logos/rentalcars.jpg",
    altKey: "_market.rentalcars_title",
    titleKey: "_market.rentalcars_title",
    descriptionKey: "_market.rentalcars_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=3955209&v=115953&q=520699&r=393339" },
  },
  {
    id: "markenkoffer",
    logoSrc: "/logos/markenkoffer.jpg",
    altKey: "_market.markenkoffer_title",
    titleKey: "_market.markenkoffer_title",
    descriptionKey: "_market.markenkoffer_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=2283645&v=10107&q=351083&r=393339" },
  },
  {
    id: "sport_thieme",
    logoSrc: "https://pimage.sport-thieme.de/affiliate-banner/googleads-logo-120x60",
    altKey: "_market.sport_thieme_title",
    titleKey: "_market.sport_thieme_title",
    descriptionKey: "_market.sport_thieme_description",
    action: { type: "newtab", link: "https://www.sportmeeting.de/sport-thieme" },
  },
  {
    id: "ferienhaus_guide",
    logoSrc: "/logos/ferienhaus_guide.png",
    altKey: "_market.ferienhaus_guide_title",
    titleKey: "_market.ferienhaus_guide_title",
    descriptionKey: "_market.ferienhaus_guide_description",
    action: { type: "newtab", link: "https://www.ferienhaus.guide" },
  },
  {
    id: "leonardo_hotels_de",
    logoSrc: "/logos/leonardo_hotels_de.png",
    altKey: "_market.leonardo_hotels_title",
    titleKey: "_market.leonardo_hotels_title",
    descriptionKey: "_market.leonardo_hotels_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=3518962&v=49419&q=478323&r=393339" },
  },
  {
    id: "achat_hotels_de",
    logoSrc: achatLogo,
    altKey: "_market.achat_hotels_title",
    titleKey: "_market.achat_hotels_title",
    descriptionKey: "_market.achat_hotels_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=2684501&v=18666&q=393945&r=393339" },
  },
  {
    id: "forte_village",
    logoSrc: "/forte.png",
    altKey: "_market.fortvillage_title",
    titleKey: "_market.fortvillage_title",
    descriptionKey: "_market.fortvillage_description",
    action: { type: "modal", htmlDescriptionKey: "_market.fortvillage_description_html", link: "https://forte-village.de/" },
  },
  {
    id: "emirate_de",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.emirate_title",
    titleKey: "_market.emirate_title",
    descriptionKey: "_market.emirate_description",
    action: { type: "modal", htmlDescriptionKey: "_market.emirate_description_html", link: "https://forte-village.de/" },
  },
  {
    id: "sigiriya",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.sigiriya_title",
    titleKey: "_market.sigiriya_title",
    descriptionKey: "_market.sigiriya_description",
    action: { type: "modal", htmlDescriptionKey: "_market.emirate_description_html", link: "https://www.sigiriya.de/" },
  },
  {
    id: "fuerte",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.fuerte_title",
    titleKey: "_market.fuerte_title",
    descriptionKey: "_market.fuerte_description",
    action: { type: "modal", htmlDescriptionKey: "_market.fuerte_description_html", link: "https://fuerte-ventura.de//" },
  },
  {
    id: "reesen",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.reesen_title",
    titleKey: "_market.reesen_title",
    descriptionKey: "_market.reesen_description",
    action: { type: "modal", htmlDescriptionKey: "_market.reesen_description_html", link: "https://www.reesen.lu/" },
  },
  {
    id: "camping-4-you",
    logoSrc: "https://a1.awin1.com/ads/awin/51479/imgc4ylogo486x60-1684833559107.png",
    altKey: "_market.camping_4_you_title",
    titleKey: "_market.camping_4_you_title",
    descriptionKey: "_market.camping_4_you_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=3388719&v=51479&q=464834&r=393339" },

    // action: { type: "modal", htmlDescriptionKey: "_market.camping_4_you_description_html", link: "https://www.camping-4-you.de/" },
  },
  {
    id: "alps",
    logoSrc: alpsLogo,
    altKey: "_market.alps_title",
    titleKey: "_market.alps_title",
    descriptionKey: "_market.alps_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=3861188&v=77556&q=511986&r=393339" },

    // action: { type: "modal", htmlDescriptionKey: "_market.camping_4_you_description_html", link: "https://www.camping-4-you.de/" },
  },
  {
    id: "easybett",
    logoSrc: "https://a1.awin1.com/ads/awin/16018/imghde_logo-100x18-1693901520212.png",
    altKey: "_market.easybett_title",
    titleKey: "_market.easybett_title",
    descriptionKey: "_market.easybett_description",
    action: { type: "newtab", link: "https://www.awin1.com/awclick.php?gid=358910&mid=16018&awinaffid=393339&linkid=2352241&clickref=" },
  },
  {
    id: "tennispoint",
    logoSrc: tennisLogo,
    altKey: "_market.tennispoint_title",
    titleKey: "_market.tennispoint_title",
    descriptionKey: "_market.tennispoint_description",
    action: { type: "newtab", link: "https://www.awin1.com/awclick.php?gid=324869&mid=10984&awinaffid=393339&linkid=2060816&clickref=" },
  },
   {
    id: "uhlsport",
    logoSrc: uhlLogo,
    altKey: "_market.uhlsport_title",
    titleKey: "_market.uhlsport_title",
    descriptionKey: "_market.uhlsport_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=3620419&v=65462&q=475596&r=393339" },
  },
  {
    id: "bike",
    logoSrc: "https://www.awin1.com/cshow.php?s=4749065&v=125914&q=602597&r=393339",
    altKey: "_market.bike_title",
    titleKey: "_market.bike_title",
    descriptionKey: "_market.bike_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=4749065&v=125914&q=602597&r=393339" },
  },
  {
    id: "watery",
    logoSrc: "https://www.awin1.com/cshow.php?s=4750082&v=125166&q=602683&r=393339",
    altKey: "_market.watery_title",
    titleKey: "_market.watery_title",
    descriptionKey: "_market.watery_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=4750082&v=125166&q=602683&r=393339" },
  },
  {
    id: "camping",
    logoSrc: "https://www.awin1.com/cshow.php?s=3317229&v=44063&q=456277&r=393339",
    altKey: "_market.camping_title",
    titleKey: "_market.camping_title",
    descriptionKey: "_market.camping_description",
    action: { type: "newtab", link: "https://www.awin1.com/cread.php?s=3317229&v=44063&q=456277&r=393339" },
  },
  
]);

const travelShopIds = new Set([
  "beachcom",
  "vacationize",
  "aiakus",
  "sportmeeting_de",
  "jochen_schweizer_arena",
  "zen_hotels",
  "a_rosa",
  "lastminute366",
  "eurocamp",
  "sunparks",
  "centerparcs",
  "check24",
  "flights",
  "ferries",
  "rentalcars",
  // "markenkoffer",
  "ferienhaus_guide",
  "camping",
  "leonardo_hotels_de",
  "achat_hotels_de",
  "forte_village",
  "emirate_de",
  "sigiriya",
  "fuerte",
  "reesen",
  "alps",
  "easybett",
]);

const MarketPage = () => {
  const { t } = useContext(LanguageContext);
  const [token, setToken] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", htmlDescription: "", link: "" });

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes fadeIn { from { opacity: 0; transform: scale(0.97); } to { opacity: 1; transform: scale(1); } }
      .modal-body a { color: #004080; font-weight: 500; text-decoration: underline; }
      .modal-body a:hover { color: #0066cc; }
      @media (max-width: 768px) {
        .market-grid { grid-template-columns: 1fr !important; }
        .market-heading { font-size: 1.8rem !important; }
        .market-card h2 { font-size: 1.2rem !important; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/market/token`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        const data = await res.json();
        if (data?.token) setToken(data.token);
      } catch (err) {
        console.error("Failed to fetch market token:", err);
      }
    };
    fetchToken();
  }, []);

  const handleBeachcomClick = () => {
    const url = token ? `https://beachcom.de?token=${token}` : `https://beachcom.de`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const openModalWith = (title, htmlDescription, link) => {
    setModalContent({ title, htmlDescription, link });
    setModalOpen(true);
  };

  // Build shops list from local config (rebuilds when language or handler changes)
  const shops = useMemo(() => buildShops(t, handleBeachcomClick), [t, handleBeachcomClick]);
  const travelShops = useMemo(() => shops.filter((shop) => travelShopIds.has(shop.id)), [shops]);
  const shopShops = useMemo(() => shops.filter((shop) => !travelShopIds.has(shop.id)), [shops]);

  const renderShopsTable = (items) => (
    <div className="overflow-x-auto shadow-sm rounded">
      <table className="min-w-full border-collapse">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-3 py-2 text-left font-semibold text-sm">{t('_market.logo')}</th>
            <th className="border px-3 py-2 text-left font-semibold text-sm">{t('_market.link')}</th>
            <th className="border px-3 py-2 text-left font-semibold text-sm">{t('_market.description')}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((shop) => (
            <tr key={shop.id}>
              <td className="border px-3 py-2">
                <img src={shop.logoSrc} alt={t(shop.altKey)} className="h-12" />
              </td>
              <td className="border px-3 py-2">
                <button
                  onClick={() => {
                    const a = shop.action;
                    if (a.type === "modal") {
                      openModalWith(t(shop.titleKey), t(a.htmlDescriptionKey), a.link);
                    } else if (a.type === "custom") {
                      a.handler();
                    } else if (a.type === "newtab") {
                      window.open(a.link, "_blank", "noopener,noreferrer");
                    }
                  }}
                  className="text-blue-900 font-medium underline"
                >
                  {t(shop.titleKey)}
                </button>
              </td>
              <td className="border px-3 py-2">{t(shop.descriptionKey)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div style={containerStyle}>
      <h1 className="market-heading" style={headingStyle}>{t('_market.heading')}</h1>

      <div className="market-grid" style={gridStyle}>
        <div className="market-card" style={cardStyle}>
          <h2 style={cardHeadingStyle}>{t('_market.forTokenHolders')}</h2>
          <p>{t('_market.forTokenHolders_line1')}</p>
          <p>{t('_market.forTokenHolders_line2')}</p>
        </div>
        <div className="market-card" style={cardStyle}>
          <h2 style={cardHeadingStyle}>{t('_market.forShopOwners')}</h2>
          <p>{t('_market.forShopOwners_line1')}</p>
          <p>{t('_market.forShopOwners_line2')} <a href="mailto:info@teamcoin.de" style={{ color: "#004080", fontWeight: "600" }}>info@teamcoin.de</a></p>
          <p>{t('_market.forShopOwners_line3')}</p>
        </div>
      </div>

      <section>
        <h2 style={sectionHeadingStyle}>{t('_market.steps_heading')}</h2>
        <div style={wizardContainerStyle}>
          {[0,1,2,3].map((i) => (
            <div key={i} style={wizardStepStyle}>
              <div style={wizardCircleStyle}>{i+1}</div>
              <div style={wizardTextStyle}>{t(`_market.steps_list.${i}`)}</div>
              {i < 3 && <div style={wizardFlexLineStyle} />}
            </div>
          ))}
        </div>
      </section>

      <h2 style={{ ...sectionHeadingStyle, marginTop: "30px" }}>REISEN, URLAUB</h2>
      {renderShopsTable(travelShops)}

      <h2 style={{ ...sectionHeadingStyle, marginTop: "40px" }}>{t('_market.shops').toUpperCase()}</h2>
      <p style={{ marginTop: "20px" }}>
        {t('_market.intro_new_line1')}
      </p>
      <p>
        {t('_market.intro_new_line2')}{" "}
        <a href="mailto:info@teamcoin.de">info@teamcoin.de</a>
      </p>
      {renderShopsTable(shopShops)}

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} content={modalContent} />
    </div>
  );
};

const Modal = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null;
  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <button onClick={onClose} style={modalCloseButtonStyle}>×</button>
        <h3 style={modalTitleStyle}>{content.title}</h3>
        <div style={{ ...modalBodyStyle }} className="modal-body" dangerouslySetInnerHTML={{ __html: content.htmlDescription }} />
        <a href={content.link} target="_blank" rel="noopener noreferrer" style={modalLinkStyle}
          onMouseOver={(e) => (e.target.style.color = '#0066cc')}
          onMouseOut={(e) => (e.target.style.color = '#004080')}>
          Visit Website →
        </a>
      </div>
    </div>
  );
};

/* ---- styles (unchanged) ---- */
const containerStyle = { maxWidth: "1400px", margin: "40px auto", padding: "20px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", color: "#333" };
const headingStyle = { fontSize: "2.2rem", fontWeight: "700", textAlign: "center", marginBottom: "2rem", color: "#004080", letterSpacing: "0.5px" };
const gridStyle = { display: "grid", gap: "20px", gridTemplateColumns: "1fr 1fr", marginBottom: "30px" };
const cardStyle = { backgroundColor: "#f9f9f9", padding: "20px", borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", lineHeight: "1.6" };
const cardHeadingStyle = { fontSize: "1.3rem", color: "#004080", marginBottom: "0.5rem" };
const sectionHeadingStyle = { fontSize: "1.6rem", color: "#004080", marginBottom: "1rem", borderBottom: "2px solid #ddd", paddingBottom: "0.3rem" };

const wizardContainerStyle = { display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap", margin: "20px 0" };
const wizardStepStyle = { display: "flex", alignItems: "center", flex: "1 1 260px", minWidth: "240px", minHeight: "40px" };
const wizardCircleStyle = { width: "32px", height: "32px", borderRadius: "50%", backgroundColor: "#004080", color: "#fff", fontWeight: 700, fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 };
const wizardTextStyle = { marginLeft: "10px", fontSize: "14px", lineHeight: 1.3 };
const wizardFlexLineStyle = { height: "2px", backgroundColor: "#ccc", flex: 1, marginLeft: "12px" };

const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, animation: 'fadeIn 0.3s ease-in-out' };
const modalContentStyle = { backgroundColor: '#fff', padding: '30px 25px', borderRadius: '12px', maxWidth: '550px', width: '90%', maxHeight: '80vh', overflowY: 'auto', position: 'relative', boxShadow: '0 15px 30px rgba(0,0,0,0.15)', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", lineHeight: '1.6', fontSize: '15px', color: '#222' };
const modalCloseButtonStyle = { position: 'absolute', top: '12px', right: '14px', fontSize: '1.3rem', background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontWeight: 'bold' };
const modalTitleStyle = { fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004080' };
const modalBodyStyle = { fontSize: '0.95rem', color: '#333', lineHeight: '1.6' };
const modalLinkStyle = { display: 'inline-block', marginTop: '20px', color: '#004080', fontWeight: '600', textDecoration: 'none', transition: 'color 0.3s ease' };

export default MarketPage;
